import { FC } from 'react'

import { IconStop } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const EndNodeIcon: FC<IconProps> = ({ boxSize, theme = 'green' }) => {
  return (
    <NodeIconTemplate icon={<IconStop />} theme={theme} boxSize={boxSize} />
  )
}
